import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSync32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowSync32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.806 9.239c-3.75-1.005-7.428 1.066-8.52 4.761h3.208a1 1 0 1 1 0 2h-6.5V9.5a1 1 0 1 1 2 0v2.353c1.89-3.727 6.093-5.681 10.33-4.546 2.203.59 3.992 1.905 5.163 3.632a1 1 0 1 1-1.655 1.123c-.902-1.33-2.286-2.357-4.027-2.823m-3.612 13.528c3.75 1.004 7.427-1.066 8.52-4.762h-3.209a1 1 0 1 1 0-2h6.5v6.5a1 1 0 1 1-2 0v-2.353c-1.89 3.728-6.093 5.682-10.329 4.546-2.204-.59-3.993-1.905-5.164-3.631a1 1 0 0 1 1.655-1.123c.902 1.329 2.287 2.356 4.027 2.823"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSync32);
